var map = {
	"./1albya-alt.svg": "41d1",
	"./1albya.svg": "9274",
	"./1default-alt.svg": "977f",
	"./1default.svg": "667b",
	"./albya-alt.svg": "b9de",
	"./albya.svg": "f787",
	"./ase-alt.svg": "4894",
	"./ase.svg": "57b0",
	"./ceiba-alt.svg": "22a1",
	"./ceiba.svg": "ad39",
	"./dash-alt.svg": "5a5d",
	"./dash.svg": "9590",
	"./default-alt.svg": "03ab",
	"./default.svg": "b58c",
	"./deragopyan-alt.svg": "9b86",
	"./deragopyan.svg": "3f3b",
	"./fielseg-alt.svg": "800c",
	"./fielseg.svg": "e1eb",
	"./formosa-alt.svg": "3917",
	"./formosa.svg": "9fa0",
	"./gye-alt.svg": "c7b0",
	"./gye.svg": "e666",
	"./iadt-alt.svg": "97bc",
	"./iadt.svg": "4fc5",
	"./issemym-alt.svg": "ab3c",
	"./issemym.svg": "facd3",
	"./juncal-alt.svg": "640d",
	"./juncal.svg": "9003",
	"./mdm-alt.svg": "34c7",
	"./mdm.svg": "8020",
	"./musux-alt.svg": "0e8d",
	"./musux.svg": "ff9e",
	"./osde-alt.svg": "18e3",
	"./osde.svg": "7ce6",
	"./oslp-alt.svg": "e9a0",
	"./oslp.svg": "c4d2",
	"./smd-alt.svg": "e506",
	"./smd.svg": "7628",
	"./urg-alt.svg": "318e",
	"./urg.svg": "611e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f99c";